/******************************************************************************
 * GraphicUtils Class
 * version: 1.0.1, release: 07.09.2018
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/


//============================================================================= GraphicUtils Class
// export class GraphicUtils {
// }

// ---------------------------------------------------------------------------- resizeCanvas
// resize an existing canvas to a new canvas and return it
//
// TODO: use fill options (fit, contain, cover, ...)
//
export const resizeCanvas = (src, newWidth=0, newHeight=0) => {
	if (!src) return null

	if (!newWidth && !newHeight){
		console.error('resizeCanvas: need newWidth or newHeight')
		return null
	}

	// Create new canvas
	const canvas = document.createElement('canvas');
	const ctx = canvas.getContext('2d');

	// Calculate new dimensions while maintaining aspect ratio
	const width = src.width;
	const height = src.height;
	const aspectRatio = width / height;

	if (!newWidth){
		newWidth = newHeight * aspectRatio

	}else if (!newHeight){
		newHeight = newWidth / aspectRatio
	}

	// let newWidth, newHeight;
	// if (width > height) {
	// 	newWidth = Math.min(maxWidth, width);
	// 	newHeight = newWidth / aspectRatio;
	// } else {
	// 	newHeight = Math.min(maxHeight, height);
	// 	newWidth = newHeight * aspectRatio;
	// }

	// Set canvas dimensions
	canvas.width = newWidth;
	canvas.height = newHeight;

	// Draw image on canvas with new dimensions
	ctx.drawImage(src, 0, 0, newWidth, newHeight);

	return canvas
}


// ---------------------------------------------------------------------------- createVideoThumb
// scale: *contain, cover, fit,
//		auto,		//take the current size of the video
//		resize,		//resize inside the current canvas size
//
// todo: optimize downscaling!
//
export const createVideoThumb = (video, canvas, scale='contain', background='#000') => {
	if (!video || !canvas) return;

	let vw = video.videoWidth;
	let vh = video.videoHeight;
	let vr = vw / vh;
	let x, y, w, h;

	if (vr > canvas.width / canvas.height){
		w = canvas.width;
		h = canvas.width / vr;
		x = 0;
		y = (canvas.height - h) / 2;
	}else{
		w = canvas.height * vr;
		h = canvas.height;
		x = (canvas.width - w) / 2;
		y = 0;
	}

	let ctx = canvas.getContext('2d');
	if (background && scale === 'contain'){
		ctx.fillStyle = background;
		ctx.fillRect(0, 0, canvas.width, canvas.height);
	}

	ctx.drawImage(video, 0, 0, vw, vh, x, y, w, h);
}


// ---------------------------------------------------------------------------- createVideoMap
export const createVideoMap = (videoUrl, options) => {
	let video = document.createElement('video');
	video.autoplay = false;
	// video.width = 300;
	// video.height = 200;
	video.src = videoUrl;
	let width = 400;
	let height = 300;

	// let canvas = options && options.canvas || document.createElement('canvas');
	// let ctx = canvas.getContext('2d');
	let canvas = (options && options.canvas) || document.createElement('canvas');
	let ctx = canvas.getContext('2d');
	let id = 0;
	let step;
	let split = 8;

	let c2, c3, ct2, ct3;

	video.addEventListener('loadedmetadata', e => {
		console.log('metadata:', e.target);

		step = video.duration / (split * split);

		let r = video.videoWidth / video.videoHeight;
		height = width / r;	

		canvas.width = width * split;
		canvas.height = height * split;

// c2 = document.createElement('canvas');
// c2.width = video.videoWidth / 2;
// c2.height = video.videoHeight / 2;
// ct2 = c2.getContext('2d');

// c3 = document.createElement('canvas');
// c3.width = video.videoWidth / 4;
// c3.height = video.videoHeight / 4;
// ct3 = c3.getContext('2d');

		video.currentTime = step;
	})
	
	video.addEventListener('seeked', e => {
		// console.log('seeked', video.currentTime);
		// ctx.drawImage(video, 0, 0, width, height);

		if (id < split * split){
			let px = id % split * width;
			let py = Math.floor(id / split) * height;

// ct2.drawImage(video, 0, 0, c2.width, c2.height);
// ct3.drawImage(c2, 0, 0, c3.width, c3.height);
// ctx.drawImage(c3, 0, 0, c3.width, c3.height, px, py, width, height);

			ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight, px, py, width, height);

			id ++;
			video.currentTime = id * step;

		}else{	//finish
			console.log('finish!');
			options && options.onComplete && options.onComplete(canvas);
			// if (options.canvas){
			// 	options.canvas.width = width * split;
			// 	options.canvas.height = height * split;
			// 	options.canvas.getContext('2d').drawImage(canvas, 0, 0);
			// }
		}
	})

	return canvas;
}